import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { initialRooms } from 'lib/offer/occupancyUtils'
import { createSelector } from 'reselect'
import { multiRoomEnabled } from '../featuresSelectors'
import { isLEHotel } from 'lib/offer/offerTypes'

/**
 * Returns whether multiple room booking is active or not.
 * This includes the related feature flags and other variables that go into it
 */
export const isMultipleRoomBookingActive = createSelector(
  (state: OfferPageState) => state.rooms ?? initialRooms,
  (state: OfferPageState, appState: App.State) => !state.bundleOffer && isLEHotel(state.offer) && multiRoomEnabled(appState, state.offer),
  (rooms, isMultiRoomEnabled) => isMultiRoomEnabled && rooms.length > 1,
)
